// ==============================|| ENQUIRIES ITEMS - ENQURIES ||============================== //

import { PERMISSIONS } from "../permissions/permissions";

const enquiresComponents = {
  id: 'enquiries',
  path:"/enquiries",
  type: 'group',
  children: [
    {
      id: 'enquiries-elements',
      title: 'menu.enquiries',
      type: 'collapse',
      icon: 'ph ph-user',
      children: [
        {
          id: 'enquiries-list',
          title: 'menu.userEnquiry',
          type: 'item',
          url: '/enquiries/view-enquiries',
          permission: PERMISSIONS.ENQUIRIES.VIEW
        },
      ]
    }
  ]
};

export default enquiresComponents;